/**
 * Configuração de ambiente e feature flags (Fase 8)
 */

export type Environment = 'development' | 'production';

export interface FeatureFlags {
  /** Requer PWA instalado para login */
  requirePWAForLogin: boolean;
  /** Requer PWA instalado para signup */
  requirePWAForSignup: boolean;
  /** Habilita logs detalhados */
  enableDetailedLogs: boolean;
  /** Exibe indicador de ambiente */
  showEnvironmentBadge: boolean;
}

/**
 * Detecta o ambiente atual com base nas flags do Vite/Vercel
 */
export function getCurrentEnvironment(): Environment {
  if (import.meta.env.PROD) {
    return 'production';
  }

  return 'development';
}

/**
 * Verifica se está em ambiente de desenvolvimento
 */
export function isDevelopment(): boolean {
  return getCurrentEnvironment() === 'development';
}

/**
 * Verifica se está em ambiente de produção
 */
export function isProduction(): boolean {
  return getCurrentEnvironment() === 'production';
}

/**
 * Retorna feature flags de acordo com o ambiente
 */
export function getFeatureFlags(): FeatureFlags {
  const env = getCurrentEnvironment();

  if (env === 'development') {
    return {
      requirePWAForLogin: false,
      requirePWAForSignup: false,
      enableDetailedLogs: true,
      showEnvironmentBadge: true,
    };
  }

  return {
    requirePWAForLogin: true,
    requirePWAForSignup: false,
    enableDetailedLogs: false,
    showEnvironmentBadge: false,
  };
}

/**
 * Helper estilo hook para uso em componentes React
 */
export function useFeatureFlags(): FeatureFlags {
  return getFeatureFlags();
}
